import {observer} from "mobx-react";
import React from "react";

const HelpText = observer((props) => {
    return <small className="form-text red_text">{props.text}</small>
})

export default HelpText;